/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CryptodraftCreateBtn } from 'assets/components';
import { FLOWS, sendStats } from '../../../services/mixpanel';
import { MXP_FC_GET_VISIT } from '../mixpanel-events';
import { CardState } from '../constants';
import useRiskTierSettings from '../../../utilities/sharedHooks/useRiskTierSettings';
import { cryptodraftScreens } from '../Cryptodraft/constants';

// eslint-disable-next-line no-unused-vars
const CardOptions = ({ cardStatus = null, isCryptodraftAllowed }) => {
  const { t: translate } = useTranslation();
  const { riskAssessment } = useRiskTierSettings();
  const history = useHistory();

  const isCryptodraftEnabled = useMemo(() => {
    const isCardActive =
      cardStatus &&
      [CardState.ACTIVE, CardState.ACTIVATION].includes(cardStatus?.cardState?.toUpperCase());
    const isRiskAssessmentEnabled = riskAssessment?.settings;

    if (isRiskAssessmentEnabled) {
      return isCryptodraftAllowed && isCardActive && riskAssessment?.userRisk?.flexible_cryptodraft;
    }

    return isCryptodraftAllowed && isCardActive;
  }, [riskAssessment, cardStatus, isCryptodraftAllowed]);

  return (
    <>
      <CryptodraftCreateBtn
        className="mt-4"
        iconSize="text-f3"
        noMobile
        disabled={!isCryptodraftEnabled}
        onClick={() => {
          sendStats(MXP_FC_GET_VISIT, {}, FLOWS.FC);
          history.push('/dashboard/card/cryptodraft', { initScreen: cryptodraftScreens.PROMO });
        }}
        icon="icon-credit-limit-other"
        label={translate('cryptodraft_credit_btn_label')}
        subLabel={translate('cryptodraft_credit_btn_sublabel')}
      />
    </>
  );
};

export default CardOptions;

CardOptions.propTypes = {
  cardStatus: PropTypes.object,
  isCryptodraftAllowed: PropTypes.bool.isRequired,
};
